var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maintenancePlan mainPageBg"},[_c('Mybreadcrumb',{attrs:{"label-args":{ title2: _vm.active.title2, title3: _vm.active.title3 },"showInRoot":_vm.showInRoot,"path":{
      label:_vm.title,
      key: '1',
      children: [
        {
          label: _vm.title1,
          key: '2',
          children: [
            {
              label: _vm.title2,
              key: '3',
            },
          ],
        },
      ],
    }},model:{value:(_vm.innerPath),callback:function ($$v) {_vm.innerPath=$$v},expression:"innerPath"}}),_c('div',{staticStyle:{"height":"calc(100% - 45px)"}},[(_vm.innerPath == 1)?_c('PlanMainPage',{staticStyle:{"height":"100%"},on:{"sentIndexFn":_vm.sentIndexFn}}):(_vm.innerPath == 2)?_c('PlanDetails',{staticStyle:{"height":"100%"},attrs:{"detailData":_vm.detailData},on:{"sentPoints":_vm.sentPoints}}):(_vm.innerPath == 3)?_c('PointsDetails',{staticStyle:{"height":"100%"},attrs:{"detailData":_vm.pointsData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }